<template>
  <div class="content-box">
    <el-row class="type-content-box">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <!-- 富文本 -->
        <div v-if="styleType === '1'">
          <h2 class="title-name">{{content.title}}</h2>
          <p class="flex-box">
            <span>来源：{{content.source}}</span>
            <span>作者：{{content.author}}</span>
            <span>时间：{{content.uTime}}</span>
          </p>
          <div class="content-box-html" v-html="content.content"></div>
        </div>
        <!-- 图片列表 -->
        <div v-if="styleType === '2'" class="image-item-box">
          <el-col
            class="item-image-item"
            v-for="(item, index) in content.data"
            :key="item+index"
            :xs="8"
            :sm="8"
            :md="6"
            :lg="6"
            :xl="6"
          >
            <img @click="dialogVisible = true; dialogImageUrl = baseImageUrl + item" :src="baseImageUrl + item" />
            <el-dialog :width="screen === 'web' ? '50%' : '100%'" title="详情" :visible.sync="dialogVisible" append-to-body="false">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-col>
        </div>
        <!-- 图片轮播 -->
        <div v-if="styleType === '3'">
          <el-carousel height="4.6rem" :interval="5000" arrow="always">
            <el-carousel-item v-for="(item, index) in content.data" :key="item + index">
              <img :src="baseImageUrl + item" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 富文本卡片 -->
        <div v-if="styleType === '4'" class="rich-card-container">
          <el-col
            class="article-item-box"
            v-for="(item, index) in (pageFlag ? articleListData : content.records)"
            :key="item+index"
            :xs="12"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
          >
            <div @click="goArticleContent(item.id)" class="box-list-style">
              <div class="title-box">{{item.title}}</div>
              <div class="box-item-content">{{item.content.replace(/<.*?>/g, "") | dotdot(30)}}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-pagination
              v-if="total > 0"
              class="pagenation-box"
              background
              layout="total, prev, pager, next"
              :current-page="currentPage4"
              :total="pageFlag ? articleTotal : content.total"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </el-col>
        </div>
        <!-- 多链接列表 -->
        <div v-if="styleType === '5'" class="outer-article-box">
          <el-col
            class="url-item"
            v-for="(item, index) in (pageFlag ? articleListData : content.records)"
            :key="item+index"
            :xs="12"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
          >
            <a target="_blank" :href="item.contentUrl" class="url-box-list">
              <div class="title-box">{{item.title}}</div>
              <div class="time-box">{{item.uTime}}</div>
            </a>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-pagination
              class="pagenation-box"
              background
              :current-page="currentPage5"
              layout="total, prev, pager, next"
              :total="pageFlag ? articleTotal : content.total"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </el-col>
        </div>
        <!-- 富文本列表 -->
        <div v-if="styleType === '6'" :class="hasPicture ? `has-picture-box-prop article-content-list-box` : `list-box-common`">
          <el-col
            v-for="(item, index) in (pageFlag ? articleListData : content.records)"
            :key="item+index"
            :xs="12"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
          >
            <div v-if="hasPicture" @click="goArticleContent(item.id)" class="box-list-style">
              <div class="time-box">{{item.uTime}}</div>
              <div class="title-box" v-if="screen === 'web'">{{item.title}}</div>
              <div class="title-box" v-else>{{item.title | dotdot(20)}}</div>
            </div>
            <div v-if="!hasPicture" @click="goArticleContent(item.id)" class="box-list-style">
              <div class="title-box">{{item.title | dotdot(6)}}</div>
              <div class="box-item-content">{{item.content.replace(/<.*?>/g, "").replace(/&nbsp;/g, "") | dotdot(30)}}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-pagination
              v-if="content.total > 0"
              class="pagenation-box"
              background
              layout="total, prev, pager, next"
              :current-page="currentPage6"
              :total="pageFlag ? articleTotal : content.total"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </el-col>
        </div>
        <!-- 文字和图 -->
        <div v-if="styleType === '7' || styleType === 'IMAGE_TXT'">
          <div class="title-name">{{content.data.title}}</div>
          <div class="title-name">{{content.data.content}}</div>
          <img @click="dialogVisible = true; dialogImageUrl = baseImageUrl + content.data.imgUrl" class="image-item" :src="baseImageUrl + content.data.imgUrl" />
          <el-dialog :width="screen === 'web' ? '50%' : '100%'" title="详情" :visible.sync="dialogVisible" append-to-body="false">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </div>
        <!-- 任务和职务列表 -->
        <div v-if="styleType === '8'" class="position-container">
          <div class="position-item" v-for="(item, index) in content.data" :key="iten+index">
            <span class="position-name">{{item.name}}</span>
            <span class="position-position">{{item.position}}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//   if (type === 0) return '无样式';
//   if (type === 1) return '富文本';
//   if (type === 2) return '图片列表';
//   if (type === 3) return '图片轮播';
//   if (type === 4) return '富文本卡片';
//   if (type === 5) return '多链接列表';
//   if (type === 6) return '富文本列表';
//   if (type === 7) return '文字和图';
//   if (type === 8) return '任务职务列表';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'contentBox',
  props: {
    styleType: String,
    content: Object,
    contentArray: Array,
    hasPicture: Boolean,
  },
  data() {
    return {
      firstActiveIndex: this.$route.params.firstActiveIndex || '0',
      firstId: this.$route.params.firstId,
      secondActiveIndex: this.$route.params.secondActiveIndex || '0',
      secondId: this.$route.params.secondId,
      thirdActiveIndex: this.$route.params.thirdActiveIndex || '0',
      thirdId: this.$route.params.thirdId,
      //
      articleListData: [],
      articleTotal: 0,
      pageFlag: false,

      currentPage4: 1,
      currentPage5: 1,
      currentPage6: 1,

      dialogVisible: false,
      dialogImageUrl: ''
    };
  },
  computed: {
    ...mapGetters([
      'systemName',
      'screen',
      'baseImageUrl',
      'firstMenuMutation',
      'firstMenuMapMutation',
      'secondMenuMutation',
      'secondMenuMapMutation',
      'thirdMenuMutation',
      'thirdMenuMapMutation',
    ]),
  },
  created() {
    console.log(this.styleType, this.content, this.className, 'content======');
  },
  methods: {
    ...mapActions(['getRichTextContent', 'getRichTextContentPage']),
    goArticleContent(articleId) {
      this.$router.push(`/article/${this.firstActiveIndex}/${this.firstId}/${articleId}`);
    },
    handleCurrentChange(pageNo) {
      console.log(this.currentType, pageNo, 'page====');
      this.pageFlag = true;
      this.getRichTextContentPage({ menuId: this.secondId || this.firstId, pageSize: 10, pageNo: pageNo }).then(
        (res) => {
          if (this.styleType === '6') {
            this.currentPage6 = pageNo;          
          } else if (this.styleType === '5') {
            this.currentPage6 = pageNo;
          } else if (this.styleType === '4') {
            this.currentPage4 = pageNo;
          }
          this.articleListData = res.data.records;
          this.articleTotal = res.data.total;
        },
      );
    },
  },
};
</script>

<style scoped lang="less">
.content-box {
  .type-content-box {
    padding: 0.24rem;
    line-height: 0.5rem;
    margin-bottom: 1rem;
    .title-name {
      text-align: center;
      margin-top: 0.4rem;
      font-size: 0.4rem;
    }
    .flex-box {
      display: flex;
      justify-content: space-around;
      font-size: 0.22rem;
      color: #949494;
    }
    .content-box-html {
      font-size: 0.24rem;
      line-height: 0.5rem;
      margin-bottom: 1rem;
      img {
        width: 100% !important;
        height: 100%;
      }
    }
    .image-item-box {
      margin-top: 0.6rem;
      .item-image-item {
        padding: 0.14rem;
        img {
          width: 100%;
          height: 2rem;
        }
      }
    }
    .image-item {
      width: 100%;
      margin-top: 0.6rem;
    }
  }
  // 轮播和不轮播的公共
  .article-content-list-box {
    padding: 0 0 0 0.2rem;
  }
  .box-list-style:hover {
    background: #eee;
    color: #409eff;
  }
  .pagenation-box {
    text-align: center;
    margin: 0.1rem 0;
    padding: 0.1rem 0.2rem;
  }
  // 有轮播图的picture
  .has-picture-box-prop {
    img {
      width: 100%;
    }
    .box-list-style {
      padding: 0 0.1rem 0.2rem;
      height: auto;
    }
    .time-box {
      font-size: 0.14rem;
      font-weight: inherit;
      color: #797979;
      margin-bottom: 0.06rem;
    }
    .title-box {
      margin-bottom: 0;
      font-size: 0.22rem;
      font-weight: inherit;
    }
  }
  // 没有轮播
  .list-box-common {
    .box-list-style {
      padding: 0.16rem;
      cursor: pointer;
      height: 2rem;
    }
    .title-box {
      font-size: 0.24rem;
      font-weight: bold;
      margin-bottom: 0.2rem;
      color: #409eff;
    }
  }
  // 多链接列表
  .outer-article-box {
    .url-item {
      padding: 0.2rem;
      margin: 0;
    }
    .url-item:hover {
      background: #eee;
      color: #409eff;
    }
    .url-box-list {
      cursor: pointer;
      .time-box {
        color: #999;
        font-size: 0.2rem;
      }
      .title-box {
        color: #191919;
        font-weight: bold;
        font-size: 0.26rem;
        height: 1.2rem;
      }
    }
  }
  // 富文本卡片
  .rich-card-container {
    .article-item-box {
      .box-list-style {
        padding: 0.16rem;
        cursor: pointer;
        height: 2rem;
      }
      .title-box {
        font-size: 0.24rem;
        font-weight: bold;
        margin-bottom: 0.2rem;
        color: #409eff;
      }
    }
  }
  // 职务
  .position-container {
    margin-top: 0.4rem;
    .position-item {
      border: 1px solid #eee;
      padding: 0.4rem 0.6rem;
      background: #efefef;
      display: flex;
      align-items: center;
      margin-bottom: 0.2rem;
      .position-name {
        font-size: 0.4rem;
        // padding-right: 1rem;
        border-right: 1px solid #000;
        color: #409eff;
        width: 49%;
      }
      .position-position {
        font-size: 0.3rem;
        padding-left: 1rem;
        color: #333;
        width: 49%;
      }
    }
    .position-item:hover {
      background: #D0E8FD !important;
    }
  }
}
</style>
